import { useState } from "react";
import { normalizeTitle, type IdeaEntry, type SkillEntry } from "./skillsModel";

type Item = { id: string; label: string; hint: string; icon: string; pick: () => void };

/** Maquette G: quick search and launch from anywhere in the panel (Ctrl+K). */
export default function SkillsPalette({ skills, ideas, onSkill, onIdea, onAskChat, onClose }: {
  skills: SkillEntry[]; ideas: IdeaEntry[]; onSkill: (entry: SkillEntry) => void; onIdea: (idea: IdeaEntry) => void;
  onAskChat?: (text: string) => void; onClose: () => void;
}) {
  const [query, setQuery] = useState("");
  const [cursor, setCursor] = useState(0);
  const words = normalizeTitle(query).split(" ").filter(Boolean);
  const match = (text: string) => words.every(word => normalizeTitle(text).includes(word));
  const items: Item[] = [
    ...skills.filter(s => match(s.title + " " + s.theme)).slice(0, 8).map(s => ({ id: "s:" + s.key, label: s.title, hint: s.theme, icon: s.state === "repair" ? "×" : "●", pick: () => onSkill(s) })),
    ...ideas.filter(i => i.state === "create" && match(i.title + " " + i.theme)).slice(0, 4).map(i => ({ id: "i:" + i.key, label: i.title, hint: "idée prête à créer", icon: "+", pick: () => onIdea(i) })),
    ...(onAskChat && query.trim() ? [{ id: "chat", label: `Demander au Chat : « ${query.trim()} »`, hint: "", icon: "?", pick: () => onAskChat(query.trim()) }] : []),
  ];
  const selected = Math.min(cursor, Math.max(0, items.length - 1));
  return <div className="skills-palette" role="dialog" aria-label="Rechercher ou lancer un skill">
    <input autoFocus role="combobox" aria-expanded="true" aria-controls="skills-palette-list" aria-label="Rechercher ou lancer un skill" placeholder="Rechercher ou lancer un skill…" value={query}
      onChange={e => { setQuery(e.target.value); setCursor(0); }}
      onKeyDown={e => {
        if (e.key === "Escape") { e.preventDefault(); onClose(); }
        else if (e.key === "ArrowDown") { e.preventDefault(); setCursor(c => Math.min(c + 1, items.length - 1)); }
        else if (e.key === "ArrowUp") { e.preventDefault(); setCursor(c => Math.max(c - 1, 0)); }
        else if (e.key === "Enter" && items[selected]) { e.preventDefault(); items[selected].pick(); onClose(); }
      }} />
    <ul id="skills-palette-list" role="listbox" aria-label="Résultats">{items.map((item, index) => <li key={item.id} role="option" aria-selected={index === selected}>
      <button onMouseEnter={() => setCursor(index)} onClick={() => { item.pick(); onClose(); }}><span aria-hidden="true">{item.icon}</span>{item.label}<small>{item.hint}</small></button>
    </li>)}
      {!items.length && <li className="skills-muted">Aucun skill ne correspond.</li>}</ul>
  </div>;
}
